/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowUpSquare = createReactComponent("outline", "arrow-up-square", "IconArrowUpSquare", [["path", { "d": "M12 17l0 -14", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M10 21v-4h4v4z", "key": "svg-2" }]]);

export { IconArrowUpSquare as default };
//# sourceMappingURL=IconArrowUpSquare.mjs.map
